import React, { useState, useEffect } from 'react';

const href = (link) => {
  if (link.url === '@custom' || link.url === '@media') {
    return link.otherUrl;
  }

  return link.url || '#';
}

const media_link = (link) => !!link.src;

const link_classes = (link) => {
  if (!!link.tag) {
    return link.tag;
  }
}

const link_flags = (link) => {
  if (!!link.productFlag) {
    const { class: flagClass, colour, name } = link.productFlag;

    return (
      <span 
        key={flagClass} 
        className={`flag ${flagClass}`}
        style={{ backgroundColor: colour, borderColor: colour }}
      >{name}</span>
    );
  }
}

const megamenu_wrapper = (link) => link.url === '@wrapper';

const megamenu_link_dropdown = (link) => {
  return typeof link.sublinks != 'undefined';
}

const megamenu_link_flyout = (link) => {
  if (!!link.sublinks) {
    return link.sublinks.some(element => typeof element.sublinks != 'undefined');
  }
}

const handleFlyoutMoreClick = (event, props) => {
  event.preventDefault();

  props.active ? props.onMouseLeave() : props.onMouseEnter();
}

const handleTopLevelKeyPress = (event, props) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();

    props.onMouseEnter();
  }

  if (event.key === 'Escape') {
    event.preventDefault();

    props.onMouseLeave();
  }
};

const handleFlyoutKeypress = (event, props) => {
  if (event.key === 'Escape') {
    event.preventDefault();

    props.onMouseLeave();
  }
}

const useSupportsHover = () => {
  const [supports, setSupports] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mql = window.matchMedia('(hover: hover)');
    setSupports(mql.matches);

    const handler = (event) => setSupports(event.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return supports;
};

export { href, media_link,
         link_classes, link_flags, megamenu_wrapper,
         megamenu_link_dropdown,
         megamenu_link_flyout,
         handleFlyoutKeypress,
         handleTopLevelKeyPress,
         handleFlyoutMoreClick,
         useSupportsHover
       };
